import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
// import logo from "../assets/logodsp.png";
function Navbarr() {
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  const handleNavLinkClick = () => {
    console.log("Before:", expanded);
    setExpanded(false);
    console.log("After:", expanded);
  };

  return (
    <Navbar
      expand="lg"
      className=""
      expanded={expanded}
      style={{
        position: "fixed",
        width: "100%",

        zIndex: 1000,
        backgroundColor: "var(--primary)",
        padding: "0.1rem 0",
        height: "5rem",
      }}
    >
      <Container  fluid style={{ backgroundColor: "var(--primary)" }}>
        <Navbar.Brand
          as={Link}
          to="/"
          onClick={() => setExpanded(false)}
          style={{ margin: "0px 10px" }}
        >
        <div style={{ display: 'inline-block', position: 'relative', top: '4px' }}>
      <h4 style={{ fontWeight: '700', color: 'var(--secondary)',   fontFamily: "Cookie",letterSpacing:"2.3px", fontSize: '24px', margin: '0' }}>
       Kashaf Abdullah
      </h4>
      <p style={{ fontWeight: '400', color: 'var(--white)',  fontFamily: "Gothic A1", fontSize: '16px', margin: '0' }}>
        Web Developer & Designer
      </p>
    </div>
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="navbarScroll"
          onClick={handleToggle}
          style={{ margin: "0px 17px" }}
        />
        <Navbar.Collapse id="navbarScroll">
          <Nav className="d-flex justify-content-lg-end justify-content-center w-100  nav-items" navbarScroll>
         
           
            {/* New Route */}
            <Nav.Link as={Link} to="/" onClick={handleNavLinkClick}
            className="button-85">
              Home
            </Nav.Link>{" "}
            {/* New Route */}
            <Nav.Link as={Link} to="/work" onClick={handleNavLinkClick}
                        className="button-85">
              Work
            </Nav.Link>{" "}
            <Nav.Link as={Link} to="/certificates" onClick={handleNavLinkClick}
                        className="button-85">
             Certificates
            </Nav.Link>{" "}
         
                 {/* New Route */}
                 <Nav.Link as={Link} to="/aboutme" onClick={handleNavLinkClick}
                             className="button-85">
                    About Me
            </Nav.Link>{" "}
            {/* New Route */}
            
           <Nav.Link as={Link} to="/contact" onClick={handleNavLinkClick}
                       className="button-85">
                    Contact
            </Nav.Link>{" "}
          </Nav>

        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navbarr;
